export default class LoginDropBLock {
    constructor(element) {
        const login = element[0];
        const dropBlockItems = login && login.querySelectorAll('[data-db-target-for] , [data-db-target-of]');
        if (dropBlockItems && dropBlockItems.length) {
            dropBlockItems.forEach(item => {
                if (item.dataset?.dbTargetFor) {
                    item.removeAttribute('data-db-target-for');
                } else {
                    item.removeAttribute('data-db-target-of');
                }
            });
        }
    }
}
